import { useEffect, useState } from "react";

const NAV = [
  { label: "今日快讯", href: "#kuaiti" },
  { label: "吃瓜指数", href: "#hot" },
  { label: "事件档案", href: "#dangan" },
  { label: "合集检索", href: "#heji" },
  { label: "人物盘点", href: "#renwu" },
  { label: "主编专栏", href: "#zhuanlan" },
];

export default function Masthead() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b transition-all duration-300 ${
        solid
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-[72px] md:px-6">
        {/* brand */}
        <a href="#top" className="group flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
            <i className="ri-newspaper-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-xl font-black tracking-wide transition-colors md:text-2xl ${
                solid ? "text-foreground-950" : "text-white"
              }`}
            >
              嘿料吃瓜
            </span>
            <span
              className={`mt-1 text-[10px] font-medium tracking-[0.28em] ${
                solid ? "text-primary-600" : "text-white/80"
              }`}
            >
              黑料合集档案库
            </span>
          </span>
        </a>

        {/* nav */}
        <nav className="hidden items-center gap-7 lg:flex">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className={`whitespace-nowrap text-sm font-medium transition-colors ${
                solid ? "text-foreground-700 hover:text-primary-600" : "text-white/85 hover:text-white"
              }`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        {/* actions */}
        <div className="flex items-center gap-3">
          <span
            className={`hidden h-10 w-10 items-center justify-center rounded-full transition-colors md:flex ${
              solid ? "text-foreground-700 hover:bg-background-200" : "text-white/85 hover:bg-white/10"
            }`}
          >
            <i className="ri-search-line text-lg" />
          </span>
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-600 md:inline-block"
          >
            订阅开瓜提醒
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开导航"
            className={`flex h-10 w-10 items-center justify-center rounded-full transition-colors lg:hidden ${
              solid ? "text-foreground-950 hover:bg-background-200" : "text-white hover:bg-white/10"
            }`}
          >
            <i className={`ri-${open ? "close" : "menu"}-line text-2xl`} />
          </button>
        </div>
      </div>

      {/* mobile panel */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-4">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-200"
              >
                {n.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-400" />
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-3 text-center text-sm font-bold text-foreground-950"
            >
              订阅开瓜提醒
            </a>
          </div>
        </div>
      )}
    </header>
  );
}